import React, { Fragment } from 'react'
import { host } from '../../../../configuraciones';
import { Link, withRouter } from 'react-router-dom'
import estilos from '../Tabs/TabsInspeccionarComponent.module.css'
import estilosBuenasPracticas from '../Forms/BuenasPracticasComponent.module.css'
import { Formik, Form, Field } from 'formik';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';

import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks';

import { getPreguntaInstalacionByIdTipoInstalacion } from '../../../../redux/DucksUnidadInspeccion/PreguntaInstalacionDuck';
import { getAllSeccionesCuestionario } from '../../../../redux/DucksUnidadInspeccion/SeccionCuestionarioDuck';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { getFotoGaleriaByanexo } from '../../../../redux/DucksUnidadInspeccion/FotogaleriaDuck';

import { insertInforme } from '../../../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';
import { insertanexo } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertBuenasPracticas } from '../../../../redux/DucksUnidadInspeccion/BuenasPracticasDuck';
import { insertCalificacionPregunta } from '../../../../redux/DucksUnidadInspeccion/CalificacionPreguntaDuck';
import { insertCaratula } from '../../../../redux/DucksUnidadInspeccion/CaratulaDuck';
import { insertInstalacionHistorial } from '../../../../redux/DucksUnidadInspeccion/InstalacionesHistorialDuck';
import { insertResponsables } from '../../../../redux/DucksUnidadInspeccion/ResponsablesDuck';
import { insertResponsablesIne } from '../../../../redux/DucksUnidadInspeccion/ResponsablesDuck';
import { insertTestigos } from '../../../../redux/DucksUnidadInspeccion/TestigosDuck';
import { insertTestigosIne } from '../../../../redux/DucksUnidadInspeccion/TestigosDuck';
import { insertFi25Procesos } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoProcesosDuck';
import { insertEquipoHistorial } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoEquipoHistorial';
import { insertDataElementoClienteHistorial } from '../../../../redux/DucksUnidadInspeccion/DataElementoClienteHistorialDuck';
import { insertSuperficie } from '../../../../redux/DucksUnidadInspeccion/SuperficieDuck';
import { insertFotoGaleria } from '../../../../redux/DucksUnidadInspeccion/FotogaleriaDuck';
import { insertCumplimiento } from '../../../../redux/DucksUnidadInspeccion/CumplimientoNom070Duck';
import { updateSolicitud } from '../../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import { actualizarDictaminar } from '../../../../redux/DucksUnidadInspeccion/InstalacionDuck';

import { generarOficio } from '../../../../redux/DucksUnidadInspeccion/ArchivosDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import Collapsible from 'react-collapsible';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { faHeartPulse } from '@fortawesome/free-solid-svg-icons';
import VisualizadorPdf from '../PDF/VisualizadorPdfComponent';
import { stringify } from 'uuid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import axios from 'axios';
import { render } from '@testing-library/react';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 550,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function BuenasPracticasComponent(props) {

    const context = useContext(InspectorEnCampoContext);

    const dispatch = useDispatch()

    const todo = props.detalles;
    const idinforme = props.idinforme;
    const solicitud = props.solicitud;

    let idanexo;

    //const idanexo = useSelector(store => store.anexo.anexo);
    const fotogaleria = useSelector(store => store.FotoGaleria.FotoGaleria);
    const instalacion = props.instalacion - 1;
    const idtipoinstalacion = todo?.anexocliente[instalacion]?.informaciongeneralinstalacioncliente?.instalacionescliente[0]?.tipoinstalacion?.idtipoinstalacion;
    const tiposCalificacion = ['NO CUMPLE / NO APLICA', 'CUMPLE', 'Calificacion', 'CUMPLE PREFERENTEMENTE'];
    const verdaderaInstalacion = props.verdaderaInstalacion;

    const preguntas = useSelector(store => store.PreguntaInstalacion.PreguntaInstalacion);
    const secciones = useSelector(store => store.SeccionCuestionario.SeccionCuestionario);

    const [calificaciones, setCalificaciones] = React.useState([]);
    const [preguntasCuestionario, setPreguntasCuestionario] = React.useState([]);
    const [preguntasGuardadas, setPreguntasGuardadas] = React.useState(false);
    const [total, setTotal] = React.useState(0);
    const { buenaspracticasContext, setContextBuenasPracticas } = useContext(InspectorEnCampoContext);
    const [previsualizar, setPrevisualizar] = React.useState(true);
    const [openModalVisualizar, setOpenModalVisualizar] = React.useState(false);
    const [urlPDF, setUrlPDF] = React.useState('../../../../helpers/helpersUnidadInspeccion/InformeCumplimientoNomInstalaciones.pdf');
    const [nombreFormato, setNombreFormato] = React.useState("");

    const [fotosBase, setFotosBase] = React.useState([])
    const [informacionGuardada, setInformacionGuardada] = React.useState(false);

    useEffect(() => {

        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        // }

        if (buenaspracticasContext != null) {
            setCalificaciones(buenaspracticasContext.califiaciones)
        }
        if (idtipoinstalacion === 4 || idtipoinstalacion === 6) {
            dispatch(getPreguntaInstalacionByIdTipoInstalacion(3))
        }

        if (context.informaciongeneralContext?.data?.submit
            && context.validardomicilioContext?.data?.submit
            && context.coccionContext?.submit
            && context.destilacionContext?.submit
            && context.fermentacionContext?.submit
            && context.moliendaContext?.submit
            && context.pesadoContext?.submit
            && context.fotoGaleriaContext?.submit
            && context.buenaspracticasContext?.submit) {
            setPrevisualizar(false)
        } else {
            setPrevisualizar(true)
        }

    }, [])

    useEffect(() => {

        if (verdaderaInstalacion.idtipoanexo === 3) {
            dispatch(getPreguntaInstalacionByIdTipoInstalacion(6))   //preguntas 
        } else {
            dispatch(getPreguntaInstalacionByIdTipoInstalacion(idtipoinstalacion))   //preguntas 
        }
        dispatch(getAllSeccionesCuestionario())   //secciones  
        //dispatch(getFotoGaleriaByanexo(Number(idanexo.idfi_25anexo)))
    }, [idtipoinstalacion])

    useEffect(() => {
        if (preguntasGuardadas === false) {
            secciones.forEach((s) => {
                preguntas.forEach((p) => {
                    if (s.idseccioncuestionario === p.pregunta.idseccioncuestionario) {
                        preguntasCuestionario.push(p)
                    }
                })
            })

            setPreguntasGuardadas(true)
        }

    }, [preguntas])

    useEffect(() => {
        preguntasGuardadas

    }, [preguntasGuardadas])

    useEffect(() => {
        fotosBase
    }, [fotosBase])

    useEffect(() => {
        preguntasCuestionario
    }, [preguntasCuestionario])

    useEffect(() => {
        total
    }, [total])

    useEffect(() => {
        previsualizar
    }, [previsualizar])

    useEffect(() => {
        let i = 0;
        calificaciones.map((c) => i = i + c.calificacion);
        setTotal(i);

        const buenaspracticasContext = {
            idcuestionario: 1,
            califiaciones: calificaciones,
            calificaciontotal: total,
            observacionesresponsable: context.buenaspracticasContext?.observacionesresponsable,
            observacionesinspector: context.buenaspracticasContext?.observacionesinspector,
            preguntas: preguntasCuestionario,
            submit: false
        }

        setContextBuenasPracticas(buenaspracticasContext)
        if (preguntasCuestionario.length === 0) {
            setPreguntasGuardadas(false)
            if (idtipoinstalacion === 4 || idtipoinstalacion === 6) {
                dispatch(getPreguntaInstalacionByIdTipoInstalacion(3))   //preguntas 
            }
        }
    }, [calificaciones])

    useEffect(() => {
        fotogaleria
    }, [fotogaleria])

    useEffect(() => {
        openModalVisualizar
    }, [openModalVisualizar])

    useEffect(() => {
        urlPDF
    }, [urlPDF])

    useEffect(() => {
        nombreFormato
    }, [nombreFormato])

    useEffect(() => {
        informacionGuardada
    }, [informacionGuardada])

    const guardarInformacionEnBd = async (values) => {
        const dataInforme = {
            data: {
                idiformaciongeneralcliente: context.informaciongeneralContext.data.idinstalacion,
                idcliente: context.informaciongeneralContext.data.idcliente,
                idfc01_solicitudregistro: context.informaciongeneralContext.data.fc01.idfc01_solicitudregistro
            }
        }
        dispatch(insertInforme(dataInforme)).then((informe) => {
            const idinforme = informe.payload.data.data.idfi_25_informecumplimientonom;
            const data = {
                data: {
                    idfi_25_informecumplimientonom: informe.payload.data.data.idfi_25_informecumplimientonom,
                    idtipoanexo: context.informaciongeneralContext.data.instalacion.idtipoanexo
                }
            }
            dispatch(insertanexo(data)).then((resanexo) => {
                idanexo = resanexo.payload.data.data

                console.log(idanexo)

                //caratula
                const hoy = new Date(context.informaciongeneralContext.data.date);

                const dataCaratula = {
                    data: {
                        hora: hoy,
                        fecha: hoy,
                        solicitud: context.informaciongeneralContext.data.solicitud,
                        ninforme: context.informaciongeneralContext.data.ninforme,
                        ncomision: context.informaciongeneralContext.data.ncomision,
                        idinspector: context.informaciongeneralContext.data.inspector.idinspector,
                        idfi_25_informecumplimientonom: idinforme,
                    }
                }

                dispatch(insertCaratula(dataCaratula)).then((response) => {
                    if (response.payload.status = 200) {
                        let responsables = context.responsablesContext;
                        let testigos = context.testigosContext;
                        let idcaratula = response.payload.data.data.idfi_25caratula

                        if (responsables.length > 0) {

                            responsables.map(r => {

                                const nuevoResponsable = {
                                    data: {
                                        idfi_25caratula: idcaratula,
                                        nombre: r.nombreresponsable,
                                        edad: r.edad,
                                        telefono: r.telefono,
                                        correoelectronico: r.correoelectronico,
                                        validado: true,
                                    },
                                    imagen: r.ineFrontal,
                                    imagen2: r.inePosterior
                                }
                                dispatch(insertResponsablesIne(nuevoResponsable))
                            })

                        }

                        if (testigos.length > 0) {

                            testigos.map(t => {

                                const nuevoTestigo = {
                                    data: {
                                        idfi_25caratula: idcaratula,
                                        nombre: t.testigo,
                                    },
                                    imagen: t.ineFrontal,
                                    imagen2: t.inePosterior
                                }
                                dispatch(insertTestigosIne(nuevoTestigo))
                            })

                        }

                        //validar domicilio
                        const dataDomicilio = {
                            data: {
                                idfi_25caratula: idcaratula,
                                instalacionnumero: context.validardomicilioContext.data.instalacionnumero,
                                alias: context.validardomicilioContext.data.alias,
                                calle: context.validardomicilioContext.data.calle,
                                numeroexterior: context.validardomicilioContext.data.numeroexterior,
                                numerointerior: context.validardomicilioContext.data.numerointerior,
                                colonia: context.validardomicilioContext.data.colonia,
                                localidad: context.validardomicilioContext.data.localidad,
                                municipio: context.validardomicilioContext.data.municipio,
                                estado: context.validardomicilioContext.data.estado,
                                codigopostal: context.validardomicilioContext.data.codigopostal,
                                referenciascercanas: context.validardomicilioContext.data.referenciascercanas,
                                domicilio: context.validardomicilioContext.data.domicilio,
                                is_domicilio_verificado: true,
                                latitud_domicilio: context.validardomicilioContext.data.latitud_domicilio,
                                longitud_domicilio: context.validardomicilioContext.data.longitud_domicilio
                            }
                        }

                        dispatch(insertInstalacionHistorial(dataDomicilio))
                    }

                })

                //procesos y equipo

                if (verdaderaInstalacion.idtipoanexo === 1) {
                    ////////////////////PESADO

                    const supPesado = {
                        data: {
                            largo: parseFloat(context.pesadoContext.superficie.data.largo),
                            ancho: parseFloat(context.pesadoContext.superficie.data.ancho),
                            area: parseFloat(context.pesadoContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: context.pesadoContext.superficie.data.idseccion,
                        }
                    }

                    dispatch(insertSuperficie(supPesado))

                    let procesosPreguntasPesado = context.pesadoContext.procesosPreguntas;
                    let procesosValoresPesado = context.pesadoContext.procesos

                    if (procesosValoresPesado.length > 0) {
                        procesosPreguntasPesado.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresPesado[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {
                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoPesado = context.pesadoContext.equipoPesado;

                    if (equipoPesado.length > 0) {
                        equipoPesado.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }

                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    ////////////////////COCCION

                    const supCoccion = {
                        data: {
                            largo: parseFloat(context.coccionContext.superficie.data.largo),
                            ancho: parseFloat(context.coccionContext.superficie.data.ancho),
                            area: parseFloat(context.coccionContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: context.coccionContext.superficie.data.idseccion,
                        }
                    }

                    dispatch(insertSuperficie(supCoccion))

                    let procesosPreguntasCoccion = context.coccionContext.procesosPreguntas;
                    let procesosValoresCoccion = context.coccionContext.procesos

                    if (procesosValoresCoccion.length > 0) {
                        procesosPreguntasCoccion.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresCoccion[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {
                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoCoccion = context.coccionContext.equipoCoccion;

                    if (equipoCoccion.length > 0) {
                        equipoCoccion.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }
                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    ////////////////////MOLIENDA

                    const supMolienda = {
                        data: {
                            largo: parseFloat(context.moliendaContext.superficie.data.largo),
                            ancho: parseFloat(context.moliendaContext.superficie.data.ancho),
                            area: parseFloat(context.moliendaContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: context.moliendaContext.superficie.data.idseccion,
                        }
                    }

                    dispatch(insertSuperficie(supMolienda))

                    let procesosPreguntasMolienda = context.moliendaContext.procesosPreguntas;
                    let procesosValoresMolienda = context.moliendaContext.procesos

                    if (procesosValoresMolienda.length > 0) {
                        procesosPreguntasMolienda.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresMolienda[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {

                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoMolienda = context.moliendaContext.equipoMolienda;

                    if (equipoMolienda.length > 0) {
                        equipoMolienda.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }
                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    ////////////////////FERMENTACION

                    const supFermentacion = {
                        data: {
                            largo: parseFloat(context.fermentacionContext.superficie.data.largo),
                            ancho: parseFloat(context.fermentacionContext.superficie.data.ancho),
                            area: parseFloat(context.fermentacionContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: context.fermentacionContext.superficie.data.idseccion,
                        }
                    }

                    dispatch(insertSuperficie(supFermentacion))

                    let procesosPreguntasFermentacion = context.fermentacionContext.procesosPreguntas;
                    let procesosValoresFermentacion = context.fermentacionContext.procesos

                    if (procesosValoresFermentacion.length > 0) {
                        procesosPreguntasFermentacion.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresFermentacion[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {
                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoFermentacion = context.fermentacionContext.equipoFermentacion;

                    if (equipoFermentacion.length > 0) {
                        equipoFermentacion.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }
                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    ////////////////////DESTILACION

                    const supDestilacion = {
                        data: {
                            largo: parseFloat(context.destilacionContext.superficie.data.largo),
                            ancho: parseFloat(context.destilacionContext.superficie.data.ancho),
                            area: parseFloat(context.destilacionContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: context.destilacionContext.superficie.data.idseccion,
                        }
                    }

                    dispatch(insertSuperficie(supDestilacion))

                    let procesosPreguntasDestilacion = context.destilacionContext.procesosPreguntas;
                    let procesosValoresDestilacion = context.destilacionContext.procesos

                    if (procesosValoresDestilacion.length > 0) {
                        procesosPreguntasDestilacion.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresDestilacion[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {
                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoDestilacion = context.destilacionContext.equipoDestilacion;

                    if (equipoDestilacion.length > 0) {
                        equipoDestilacion.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }
                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }


                    ////////////////////FOTOGALERIA

                    let fotosLaboratorio = context.fotoGaleriaContext.fotosLaboratorio;
                    let fotosSanitarios = context.fotoGaleriaContext.fotosSanitarios;
                    let fotosEstacionamiento = context.fotoGaleriaContext.fotosEstacionamiento;
                    let fotosOficinas = context.fotoGaleriaContext.fotosOficinas;
                    let fotosCarga = context.fotoGaleriaContext.fotosCarga;
                    let fotosOtros = context.fotoGaleriaContext.fotosOtros;

                    let fotosPesado = context.fotoGaleriaContext.fotosPesado;
                    let fotosCoccion = context.fotoGaleriaContext.fotosCoccion;
                    let fotosMolienda = context.fotoGaleriaContext.fotosMolienda;
                    let fotosFermentacion = context.fotoGaleriaContext.fotosFermentacion;
                    let fotosDestilacion = context.fotoGaleriaContext.fotosDestilacion;
                    let fotosProductor = context.fotoGaleriaContext.fotosProductor;
                    let fotosVistaGeneral = context.fotoGaleriaContext.fotosVistaGeneral;
                    let fotosMateriaPrima = context.fotoGaleriaContext.fotosMateriaPrima;
                    let fotosRecepcionMateriaPrima = context.fotoGaleriaContext.fotosRecepcionMateriaPrima;
                    let fotosAlmacenGranel = context.fotoGaleriaContext.fotosAlmacenGranel;

                    if (fotosCoccion.length > 0) {
                        fotosCoccion.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 1,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))

                        })
                    }

                    if (fotosMolienda.length > 0) {
                        fotosMolienda.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 2,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosFermentacion.length > 0) {
                        fotosFermentacion.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 3,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosDestilacion.length > 0) {
                        fotosDestilacion.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 4,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosPesado.length > 0) {
                        fotosPesado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 14,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosLaboratorio.length > 0) {
                        fotosLaboratorio.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 20,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOficinas.length > 0) {
                        fotosOficinas.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 23,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosSanitarios.length > 0) {
                        fotosSanitarios.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 21,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEstacionamiento.length > 0) {
                        fotosEstacionamiento.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 22,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosCarga.length > 0) {
                        fotosCarga.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 33,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOtros.length > 0) {
                        fotosOtros.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 25,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosProductor.length > 0) {
                        fotosProductor.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 15,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosVistaGeneral.length > 0) {
                        fotosVistaGeneral.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 16,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosMateriaPrima.length > 0) {
                        fotosMateriaPrima.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 17,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosRecepcionMateriaPrima.length > 0) {
                        fotosRecepcionMateriaPrima.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 18,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosAlmacenGranel.length > 0) {
                        fotosAlmacenGranel.map((f, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 19,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }
                } else if (verdaderaInstalacion.idtipoanexo === 2) {
                    //////////////////////// ENVASADO

                    const cumplimientoNom070 = {
                        data: {
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idcuestionario: 2,
                        }
                    }

                    dispatch(insertCumplimiento(cumplimientoNom070)).then((resc70) => {
                        context.cuestionarioContext.procesosPreguntas.map((c, index) => {

                            const data = {
                                data: {
                                    idpregunta: c.idpregunta,
                                    idcuestionario: 2,
                                    calificacion: parseInt(context.cuestionarioContext.procesosValores[index]),
                                    idfk: resc70.payload.data.data.idfi_25cumplimientonom070
                                }
                            }
    
                            dispatch(insertCalificacionPregunta(data));
                        })
                    })
                   

                    const supPesado = {
                        data: {
                            largo: parseFloat(context.areaEnvasadoContext.superficie.data.largo),
                            ancho: parseFloat(context.areaEnvasadoContext.superficie.data.ancho),
                            area: parseFloat(context.areaEnvasadoContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: 26,
                        }
                    }

                    dispatch(insertSuperficie(supPesado))

                    let procesosPreguntasEnvasado = context.areaEnvasadoContext.procesosPreguntas;
                    let procesosValoresEnvasado = context.areaEnvasadoContext.procesos

                    if (procesosValoresEnvasado.length > 0) {
                        procesosPreguntasEnvasado.forEach((p, index) => {
                            const data = {
                                data: {
                                    idfi_25anexo: idanexo?.idfi_25anexo,
                                    comentarios: procesosValoresEnvasado[index],
                                    idproceso: p.idproceso,
                                }
                            }
                            if (data.data.comentarios != undefined) {
                                dispatch(insertFi25Procesos(data))   //PROCESOS PESADO
                            }
                        })
                    } else {
                        console.log("procesos vacio")
                    }

                    let equipoEnvasado = context.areaEnvasadoContext.equipo;

                    if (equipoEnvasado.length > 0) {
                        equipoEnvasado.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }

                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    if (context.envasadoOtrosContext != null) {

                        const supOtros = {
                            data: {
                                largo: parseFloat(context.envasadoOtrosContext.superficie.data.largo),
                                ancho: parseFloat(context.envasadoOtrosContext.superficie.data.ancho),
                                area: parseFloat(context.envasadoOtrosContext.superficie.data.area),
                                idfi_25anexo: idanexo?.idfi_25anexo,
                                idseccion: 26,
                            }
                        }

                        dispatch(insertSuperficie(supOtros))

                        let equipoEnvasadoOtros = context.envasadoOtrosContext.equipo;


                        if (equipoEnvasadoOtros.length > 0) {
                            equipoEnvasadoOtros.forEach((e) => {

                                const equipoHistorial = {
                                    data: {
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        cantidad: parseInt(e.cantidad),
                                        capacidad: parseFloat(e.capacidad),
                                        descripcion: e.descripcion,
                                        condicion: e.condicion,
                                        verificado: true,
                                        idfi_25anexo: idanexo?.idfi_25anexo
                                    }
                                }

                                const dataElementoClienteHistorial = {
                                    data: {
                                        cantidad: parseInt(e.cantidad),
                                        descripcion: e.descripcion,
                                        otro: "",
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        idseccion: e.idseccion,
                                        iddataelementocliente: e.iddataelementocliente
                                    }
                                }

                                dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                                dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                            })
                        } else {
                            console.log("vacio")
                        }
                    }

                    let fotosAlmacenGranel = context.fotoGaleriaContext.fotosAlmacenGranel;
                    let fotosAlmacenProductoEnvasado = context.fotoGaleriaContext.fotosAlmacenProductoEnvasado;
                    let fotosAreasAlmacen = context.fotoGaleriaContext.fotosAreasAlmacen;
                    let fotosEquipoFiltrado = context.fotoGaleriaContext.fotosEquipoFiltrado;
                    let fotosEquipoLlenado = context.fotoGaleriaContext.fotosEquipoLlenado;
                    let fotosEquipoSellado = context.fotoGaleriaContext.fotosEquipoSellado;
                    let fotosEquipoTaponado = context.fotoGaleriaContext.fotosEquipoTaponado;
                    let fotosLineasEnvasado = context.fotoGaleriaContext.fotosLineasEnvasado;
                    let fotosMarcas = context.fotoGaleriaContext.fotosMarcas;
                    let fotosMarcasOtros = context.fotoGaleriaContext.fotosMarcasOtros;
                    let fotosVistaGeneral = context.fotoGaleriaContext.fotosVistaGeneral;

                    let fotosLaboratorio = context.fotoGaleriaContext.fotosLaboratorio;
                    let fotosSanitarios = context.fotoGaleriaContext.fotosSanitarios;
                    let fotosEstacionamiento = context.fotoGaleriaContext.fotosEstacionamiento;
                    let fotosOficinas = context.fotoGaleriaContext.fotosOficinas;
                    let fotosCarga = context.fotoGaleriaContext.fotosCarga;
                    let fotosOtros = context.fotoGaleriaContext.fotosOtros;

                    if (fotosAlmacenGranel.length > 0) {
                        fotosAlmacenGranel.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 19,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosAlmacenProductoEnvasado.length > 0) {
                        fotosAlmacenProductoEnvasado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 27,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosAreasAlmacen.length > 0) {
                        fotosAreasAlmacen.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 29,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEquipoFiltrado.length > 0) {
                        fotosEquipoFiltrado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 6,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEquipoLlenado.length > 0) {
                        fotosEquipoLlenado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 7,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEquipoSellado.length > 0) {
                        fotosEquipoSellado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 9,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEquipoTaponado.length > 0) {
                        fotosEquipoTaponado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 8,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosLineasEnvasado.length > 0) {
                        fotosLineasEnvasado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 30,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosMarcas.length > 0) {
                        fotosMarcas.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 28,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosMarcasOtros.length > 0) {
                        fotosMarcasOtros.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 31,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosVistaGeneral.length > 0) {
                        fotosVistaGeneral.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 16,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosLaboratorio.length > 0) {
                        fotosLaboratorio.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 20,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOficinas.length > 0) {
                        fotosOficinas.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 23,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosSanitarios.length > 0) {
                        fotosSanitarios.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 21,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEstacionamiento.length > 0) {
                        fotosEstacionamiento.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 22,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosCarga.length > 0) {
                        fotosCarga.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 33,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOtros.length > 0) {
                        fotosOtros.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 25,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }


                } else if (verdaderaInstalacion.idtipoanexo === 3) {
                    //////////////////////// ALMACEN
                    const supGranel = {
                        data: {
                            largo: parseFloat(context.productoGranelContext.superficie.data.largo),
                            ancho: parseFloat(context.productoGranelContext.superficie.data.ancho),
                            area: parseFloat(context.productoGranelContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: 5,
                        }
                    }

                    dispatch(insertSuperficie(supGranel))


                    let equipoGranel = context.productoGranelContext.equipo;

                    if (equipoGranel.length > 0) {
                        equipoGranel.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }

                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    const supProductoTerminado = {
                        data: {
                            largo: parseFloat(context.productoTerminadoContext.superficie.data.largo),
                            ancho: parseFloat(context.productoTerminadoContext.superficie.data.ancho),
                            area: parseFloat(context.productoTerminadoContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: 11,
                        }
                    }

                    dispatch(insertSuperficie(supProductoTerminado))

                    let equipoProductoTerminado = context.productoTerminadoContext.equipo;


                    if (equipoProductoTerminado.length > 0) {
                        equipoProductoTerminado.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }

                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }

                    const supAlmacenMaduracion = {
                        data: {
                            largo: parseFloat(context.almacenMaduracionContext.superficie.data.largo),
                            ancho: parseFloat(context.almacenMaduracionContext.superficie.data.ancho),
                            area: parseFloat(context.almacenMaduracionContext.superficie.data.area),
                            idfi_25anexo: idanexo?.idfi_25anexo,
                            idseccion: 12,
                        }
                    }

                    dispatch(insertSuperficie(supAlmacenMaduracion))

                    let equipoAlmacenMaduracion = context.almacenMaduracionContext.equipo;

                    if (equipoAlmacenMaduracion.length > 0) {
                        equipoAlmacenMaduracion.forEach((e) => {

                            const equipoHistorial = {
                                data: {
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    cantidad: parseInt(e.cantidad),
                                    capacidad: parseFloat(e.capacidad),
                                    descripcion: e.descripcion,
                                    condicion: e.condicion,
                                    verificado: true,
                                    idfi_25anexo: idanexo?.idfi_25anexo
                                }
                            }

                            const dataElementoClienteHistorial = {
                                data: {
                                    cantidad: parseInt(e.cantidad),
                                    descripcion: e.descripcion,
                                    otro: "",
                                    idelemento: parseInt(e.elemento.idelemento),
                                    tipootros: e.elemento.tipoOtros,
                                    idseccion: e.idseccion,
                                    iddataelementocliente: e.iddataelementocliente
                                }
                            }

                            dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                            dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial

                        })
                    } else {
                        console.log("vacio")
                    }


                    let fotosAlmacenProductoTerminado = context.fotoGaleriaContext.fotosAlmacenProductoTerminado;
                    let fotosEquipoCarga = context.fotoGaleriaContext.fotosEquipoCarga;
                    let fotosAlmacenMaduracion = context.fotoGaleriaContext.fotosAlmacenMaduracion;
                    let fotosRecipientes = context.fotoGaleriaContext.fotosRecipientes;

                    let fotosLaboratorio = context.fotoGaleriaContext.fotosLaboratorio;
                    let fotosSanitarios = context.fotoGaleriaContext.fotosSanitarios;
                    let fotosEstacionamiento = context.fotoGaleriaContext.fotosEstacionamiento;
                    let fotosOficinas = context.fotoGaleriaContext.fotosOficinas;
                    let fotosCarga = context.fotoGaleriaContext.fotosCarga;
                    let fotosOtros = context.fotoGaleriaContext.fotosOtros;


                    if (fotosAlmacenProductoTerminado.length > 0) {
                        fotosAlmacenProductoTerminado.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 32,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEquipoCarga.length > 0) {
                        fotosEquipoCarga.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 33,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosAlmacenMaduracion.length > 0) {
                        fotosAlmacenMaduracion.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 34,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosRecipientes.length > 0) {
                        fotosRecipientes.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 35,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosLaboratorio.length > 0) {
                        fotosLaboratorio.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 20,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOficinas.length > 0) {
                        fotosOficinas.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 23,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosSanitarios.length > 0) {
                        fotosSanitarios.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 21,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosEstacionamiento.length > 0) {
                        fotosEstacionamiento.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 22,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosCarga.length > 0) {
                        fotosCarga.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 33,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                    if (fotosOtros.length > 0) {
                        fotosOtros.map((f, index) => {

                            const data = {
                                data: {
                                    idfi_25anexo: parseInt(idanexo?.idfi_25anexo),
                                    idseccion: 25,
                                    ruta: ""
                                },
                                imagen: f
                            }
                            dispatch(insertFotoGaleria(data))
                        })
                    }

                }


                const data = {
                    data: {
                        observacionesresponsable: values.observacionesresponsable,
                        observacionesinspector: values.observacionesinspector,
                        idfi_25anexo: idanexo?.idfi_25anexo,
                        calificaciontotal: total,
                        idcuestionario: 1
                    }
                }

                dispatch(insertBuenasPracticas(data)).then((resbp) => {
                    calificaciones.map((c) => {
                        const data = {
                            data: {
                                idpregunta: c.idpregunta,
                                idcuestionario: 1,
                                calificacion: c.calificacion,
                                idfk: resbp.payload.data.data.idfi_25buenaspracticas
                            }
                        }
    
                        dispatch(insertCalificacionPregunta(data));
                    })
                })

            
                // const dataSolicitud = {
                //     data: {
                //         idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                //         idinspector: solicitud.idinspector,
                //         fecharealdeinspeccion: solicitud.fecharealdeinspeccion,
                //         asignadopor: solicitud.asignadopor,
                //         statusdelasolicitud: 2,
                //         folioui: solicitud.folioui,
                //         ncomision: solicitud.ncomision
                //     }
                // }
                // dispatch(updateSolicitud(dataSolicitud))


                console.log("aqui")
                setInformacionGuardada(true)
            })
        })

        const data = {
            data: {
                idinstalacion: context.informaciongeneralContext.data.idinstalacion,
                isdictaminada: true,
            }
        }

        dispatch(actualizarDictaminar(data)).then((res) => {

        })
    }

    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            let canva = document.createElement("canvas");
            let nvimg = new Image();
            nvimg.src = URL.createObjectURL(blob)
            nvimg.onload = () => {
                canva.width = nvimg.width;
                canva.height = nvimg.height;
                canva.getContext("2d").drawImage(nvimg, 0, 0);
                canva.toBlob((b) => {
                    if (b != null) {
                        //const url = URL.createObjectURL(b)
                        //const enlace = document.createElement("a")
                        //enlace.href = url
                        //enlace.download = "comprimida.jpg"
                        //enlace.click()
                        const reader = new FileReader();
                        reader.readAsDataURL(b);
                        reader.onloadend = () => {
                            resolve(reader.result.split(',')[1])
                        }
                    }
                },
                    "image/jpeg",
                    0.30
                )
            }
        })
    }

    const previsualizarDocumento = async (prev) => {

        if (context.informaciongeneralContext.data.inspector === undefined) {
            alert('Datos faltantes')
        } else {

            await dispatch(actualizarLoadingApp_true())

            let nombreArchivo = "";

            let informe = context.informaciongeneralContext.data.ninforme;
            let fechaForm = "";
            let inicialesInspector = "";

            informe = informe.replace("FI25", "")
            informe = informe.replace("/", ".")

            const fecha = Date.now();
            const hoy = new Date(context.informaciongeneralContext.data.date);

            let anio = hoy.getFullYear();
            let mes = hoy.getMonth() + 1;
            let dia = hoy.getDate();


            dia = ('0' + dia).slice(-2);
            mes = ('0' + mes).slice(-2);

            let anios = String(anio)
            fechaForm = dia + "" + mes + "" + anios[2] + anios[3];

            let nombreInspector = context.informaciongeneralContext.data.inspector.nombre.split(" ");
            let apellidosInspector = context.informaciongeneralContext.data.inspector.apellidos.split(" ");

            for (let i = 0; i < nombreInspector.length; i++) {
                inicialesInspector += nombreInspector[i][0]
            }

            for (let i = 0; i < apellidosInspector.length; i++) {
                inicialesInspector += apellidosInspector[i][0]
            }

            nombreArchivo = "FI-25-" + context.informaciongeneralContext.data.numerosocio + "-" + informe + "-" + fechaForm + "-" + inicialesInspector + ".pdf"

            if (verdaderaInstalacion.idtipoanexo === 1) {
                let fotosLaboratorio = [];
                let fotosSanitarios = [];
                let fotosEstacionamiento = [];
                let fotosOficinas = [];
                let fotosCarga = [];
                let fotosOtros = [];

                let fotosPesado = [];
                let fotosCoccion = [];
                let fotosMolienda = [];
                let fotosFermentacion = [];
                let fotosDestilacion = [];
                let fotosProductor = [];
                let fotosVistaGeneral = [];
                let fotosMateriaPrima = [];
                let fotosRecepcionMateriaPrima = [];
                let fotosAlmacenGranel = [];

                try {

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosLaboratorio?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosLaboratorio.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosSanitarios?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosSanitarios.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEstacionamiento?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEstacionamiento.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOficinas?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOficinas.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosCarga?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosCarga.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOtros?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOtros.push(b64)
                        })
                    )
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosPesado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosPesado.push(b64)
                        })
                    )
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosCoccion?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosCoccion.push(b64)
                        })
                    )
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosMolienda?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosMolienda.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosFermentacion?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosFermentacion.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosDestilacion?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosDestilacion.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosProductor?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosProductor.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosVistaGeneral?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosVistaGeneral.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosMateriaPrima?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosMateriaPrima.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosRecepcionMateriaPrima?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosRecepcionMateriaPrima.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAlmacenGranel?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAlmacenGranel.push(b64)
                        })
                    )

                } catch (error) {
                    console.log(error)
                }

                let data = {
                    informacionGeneral: context.informaciongeneralContext.data,
                    responsables: context.responsablesContext,
                    testigos: context.testigosContext,
                    motivo: context.motivoContext,
                    validarDomicilio: context.validardomicilioContext?.data,
                    procesosyequipos: {
                        pesado: context.pesadoContext,
                        coccion: context.coccionContext,
                        destilacion: context.destilacionContext,
                        fermentacion: context.fermentacionContext,
                        molienda: context.moliendaContext,
                    },
                    fotosLaboratorio: fotosLaboratorio,
                    fotosSanitarios: fotosSanitarios,
                    fotosEstacionamiento: fotosEstacionamiento,
                    fotosOficinas: fotosOficinas,
                    fotosCarga: fotosCarga,
                    fotosOtros: fotosOtros,
                    fotosPesado: fotosPesado,
                    fotosCoccion: fotosCoccion,
                    fotosMolienda: fotosMolienda,
                    fotosFermentacion: fotosFermentacion,
                    fotosDestilacion: fotosDestilacion,
                    fotosProductor: fotosProductor,
                    fotosVistaGeneral: fotosVistaGeneral,
                    fotosMateriaPrima: fotosMateriaPrima,
                    fotosRecepcionMateriaPrima: fotosRecepcionMateriaPrima,
                    fotosAlmacenGranel: fotosAlmacenGranel,
                    buenaspracticas: context.buenaspracticasContext,
                    previsualizar: true,
                    generar: prev,
                    nombreArchivo: nombreArchivo,
                    tipoInforme: 1,
                    idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                    idinstalacion: context.informaciongeneralContext.data.idinstalacion
                }

                const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarOficiosPrev', {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify(data),
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                    }),
                })

                if (documento.status != 404) {
                    const blob = await documento.blob();
                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                    //window.open(url);
                    setUrlPDF(url)
                    if (prev === true) {
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = nombreArchivo;
                        a.click()
                    }
                } else {

                }
                await dispatch(actualizarLoadingApp_false())
                if (prev === false) {
                    handleOpenModalPrevisualizar()
                } else if (prev === true) {
                    Store.addNotification({
                        title: "Informe de Cumplimiento con la NOM de Instalaciones",
                        message: "Generado! Revise su carpeta de descargas",
                        type: "success",
                        insert: "top",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 2000,
                            onScreen: true,
                        }
                    });
                    setTimeout(() => {
                        Store.addNotification({
                            title: "Informe de Cumplimiento con la NOM de Instalaciones",
                            message: "Sera redirigido al panel de busqueda de asociado",
                            type: "warning",
                            insert: "top",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true,
                            }
                        });
                        setTimeout(() => {
                            window.location.href = '/PanelAsociados';
                        }, "5000")
                    }, "4000");
                }
            }

            if (verdaderaInstalacion.idtipoanexo === 2) {
                let fotosAlmacenGranel = [];
                let fotosAlmacenProductoEnvasado = [];
                let fotosAreasAlmacen = [];
                let fotosEquipoFiltrado = [];
                let fotosEquipoLlenado = [];
                let fotosEquipoSellado = [];
                let fotosEquipoTaponado = [];
                let fotosLineasEnvasado = [];
                let fotosMarcas = [];
                let fotosMarcasOtros = [];
                let fotosVistaGeneral = [];

                let fotosLaboratorio = [];
                let fotosSanitarios = [];
                let fotosEstacionamiento = [];
                let fotosOficinas = [];
                let fotosCarga = [];
                let fotosOtros = [];

                try {
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAlmacenGranel?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAlmacenGranel.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAlmacenProductoEnvasado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAlmacenProductoEnvasado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAreasAlmacen?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAreasAlmacen.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEquipoFiltrado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEquipoFiltrado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEquipoLlenado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEquipoLlenado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEquipoSellado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEquipoSellado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEquipoTaponado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEquipoTaponado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosLineasEnvasado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosLineasEnvasado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosMarcas?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosMarcas.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosMarcasOtros?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosMarcasOtros.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosVistaGeneral?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosVistaGeneral.push(b64)
                        })
                    )
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosLaboratorio?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosLaboratorio.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosSanitarios?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosSanitarios.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEstacionamiento?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEstacionamiento.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOficinas?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOficinas.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosCarga?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosCarga.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOtros?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOtros.push(b64)
                        })
                    )
                } catch (error) {
                    console.log(error)
                }

                let data = {
                    informacionGeneral: context.informaciongeneralContext.data,
                    responsables: context.responsablesContext,
                    testigos: context.testigosContext,
                    motivo: context.motivoContext,
                    validarDomicilio: context.validardomicilioContext?.data,
                    procesosyequipos: {
                        areaenvasado: context.areaEnvasadoContext,
                        envasadoOtros: context.envasadoOtrosContext,
                    },
                    fotosAlmacenGranel: fotosAlmacenGranel,
                    fotosAlmacenProductoEnvasado: fotosAlmacenProductoEnvasado,
                    fotosAreasAlmacen: fotosAreasAlmacen,
                    fotosEquipoFiltrado: fotosEquipoFiltrado,
                    fotosEquipoLlenado: fotosEquipoLlenado,
                    fotosEquipoSellado: fotosEquipoSellado,
                    fotosEquipoTaponado: fotosEquipoTaponado,
                    fotosLineasEnvasado: fotosLineasEnvasado,
                    fotosMarcas: fotosMarcas,
                    fotosMarcasOtros: fotosMarcasOtros,
                    fotosVistaGeneral: fotosVistaGeneral,
                    fotosLaboratorio: fotosLaboratorio,
                    fotosSanitarios: fotosSanitarios,
                    fotosEstacionamiento: fotosEstacionamiento,
                    fotosOficinas: fotosOficinas,
                    fotosCarga: fotosCarga,
                    cuestionario: context.cuestionarioContext,
                    fotosOtros: fotosOtros,
                    buenaspracticas: context.buenaspracticasContext,
                    previsualizar: true,
                    generar: prev,
                    nombreArchivo: nombreArchivo,
                    tipoInforme: 2,
                    idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                    idinstalacion: context.informaciongeneralContext.data.idinstalacion
                }

                const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarOficiosPrev', {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify(data),
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                    }),
                })

                if (documento.status != 404) {
                    const blob = await documento.blob();
                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                    //window.open(url);
                    setUrlPDF(url)
                    if (prev === true) {
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = nombreArchivo;
                        a.click()

                    }
                } else {

                }
                await dispatch(actualizarLoadingApp_false())
                if (prev === false) {
                    handleOpenModalPrevisualizar()
                } else if (prev === true) {
                    Store.addNotification({
                        title: "Informe de Cumplimiento con la NOM de Instalaciones",
                        message: "Generado! Revise su carpeta de descargas",
                        type: "success",
                        insert: "top",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 2000,
                            onScreen: true,
                        }
                    });
                    setTimeout(() => {
                        Store.addNotification({
                            title: "Informe de Cumplimiento con la NOM de Instalaciones",
                            message: "Sera redirigido al panel de busqueda de asociado",
                            type: "warning",
                            insert: "top",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true,
                            }
                        });
                        setTimeout(() => {
                            window.location.href = '/PanelAsociados';
                        }, "5000")
                    }, "4000");
                }
            }

            if (verdaderaInstalacion.idtipoanexo === 3) {
                let fotosAlmacenProductoTerminado = [];
                let fotosEquipoCarga = [];
                let fotosAlmacenMaduracion = [];
                let fotosRecipientes = [];

                let fotosLaboratorio = [];
                let fotosSanitarios = [];
                let fotosEstacionamiento = [];
                let fotosOficinas = [];
                let fotosCarga = [];
                let fotosOtros = [];


                try {
                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAlmacenProductoTerminado?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAlmacenProductoTerminado.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEquipoCarga?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEquipoCarga.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosAlmacenMaduracion?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosAlmacenMaduracion.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosRecipientes?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosRecipientes.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosLaboratorio?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosLaboratorio.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosSanitarios?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosSanitarios.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosEstacionamiento?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosEstacionamiento.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOficinas?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOficinas.push(b64)
                        })

                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosCarga?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosCarga.push(b64)
                        })
                    )

                    await Promise.all(
                        context.fotoGaleriaContext?.fotosOtros?.map(async (element) => {
                            const b64 = await blobToBase64(element);
                            fotosOtros.push(b64)
                        })
                    )
                } catch (e) {
                    console.log(e)
                }

                let data = {
                    informacionGeneral: context.informaciongeneralContext.data,
                    responsables: context.responsablesContext,
                    testigos: context.testigosContext,
                    motivo: context.motivoContext,
                    validarDomicilio: context.validardomicilioContext?.data,
                    procesosyequipos: {
                        productoGranel: context.productoGranelContext,
                        productoTerminado: context.productoTerminadoContext,
                        maduracion: context.almacenMaduracionContext,
                    },
                    fotosAlmacenProductoTerminado: fotosAlmacenProductoTerminado,
                    fotosEquipoCarga: fotosEquipoCarga,
                    fotosAlmacenMaduracion: fotosAlmacenMaduracion,
                    fotosRecipientes: fotosRecipientes,
                    fotosLaboratorio: fotosLaboratorio,
                    fotosSanitarios: fotosSanitarios,
                    fotosEstacionamiento: fotosEstacionamiento,
                    fotosOficinas: fotosOficinas,
                    fotosCarga: fotosCarga,
                    fotosOtros: fotosOtros,
                    buenaspracticas: context.buenaspracticasContext,
                    previsualizar: true,
                    generar: prev,
                    nombreArchivo: nombreArchivo,
                    tipoInforme: 3,
                    idsolicitudesuifc01: solicitud.idsolicitudesuifc01,
                    idinstalacion: context.informaciongeneralContext.data.idinstalacion
                }

                const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarOficiosPrev', {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify(data),
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                    }),
                })

                if (documento.status != 404) {
                    const blob = await documento.blob();
                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                    //window.open(url);
                    setUrlPDF(url)
                    if (prev === true) {
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = nombreArchivo;
                        a.click()
                    }
                } else {

                }
                await dispatch(actualizarLoadingApp_false())
                if (prev === false) {
                    handleOpenModalPrevisualizar()
                } else if (prev === true) {
                    Store.addNotification({
                        title: "Informe de Cumplimiento con la NOM de Instalaciones",
                        message: "Generado! Revise su carpeta de descargas",
                        type: "success",
                        insert: "top",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 2000,
                            onScreen: true,
                        }
                    });
                    setTimeout(() => {
                        Store.addNotification({
                            title: "Informe de Cumplimiento con la NOM de Instalaciones",
                            message: "Sera redirigido al panel de busqueda de asociado",
                            type: "warning",
                            insert: "top",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true,
                            }
                        });
                        setTimeout(() => {
                            window.location.href = '/PanelAsociados';
                        }, "5000")
                    }, "4000");
                }
            }
        }
    }

    const handleCalificaciones = (p, event, indexSeccion, index) => {
        let calificacion = parseInt(event.target.value)
        if (calificaciones.length > 0) {
            let pregunta = calificaciones.filter((c) => {
                if (c.idpregunta === p) {
                    c.calificacion = calificacion;
                    let i = 0;
                    calificaciones.map((c) => i = i + c.calificacion);
                    setTotal(i);
                    return c;
                }
            })
            if (pregunta.length === 0) {
                setCalificaciones([...calificaciones,
                {
                    idpregunta: p,
                    calificacion: calificacion
                }]);
            } else {
                calificaciones
            }
        } else {
            setCalificaciones([...calificaciones,
            {
                idpregunta: p,
                calificacion: calificacion
            }]);
        }

        let text = String('calificacioninstalaciones' + indexSeccion + index)

        if (event.target.value > -1 && event.target.value != NaN) {
            let aux = document.getElementById(text);
            aux.style.backgroundColor = 'rgb(213,245,227)'
        }
    }



    const checkSeccion = (event, indexSeccion) => {
        let text = String('seccion' + indexSeccion)
        let text2 = String('check' + indexSeccion)
        let aux = document.getElementById(text);
        let aux2 = document.getElementById(text2);
        aux.classList.toggle("successSeccion");
        aux2.classList.toggle("successSeccion");
    }

    const handleOpenModalPrevisualizar = () => {
        setOpenModalVisualizar(true);
    }
    const handleCloseModalPrevisualizar = () => {
        setOpenModalVisualizar(false);
    }

    const modalPrevisualizarPDF = () => {
        return (
            <div>
                <Modal
                    open={openModalVisualizar}
                    onClose={handleCloseModalPrevisualizar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                PREVISUALIZACION DE INFORME DE CUMPLIMIENTO
                            </div>
                        </Typography>
                        <Box>

                        </Box>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} height={400}>
                            <div style={{ width: "95%", backgroundColor: "black", height: "55px", position: "absolute" }}>
                            </div>
                            <object
                                data={urlPDF}
                                width="948"
                                height="450"
                            >
                            </object>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }


    return (
        <Fragment>
            <Formik
                initialValues={{

                }}
                validate={(values) => {
                    const buenaspracticasContext = {
                        idcuestionario: 1,
                        califiaciones: calificaciones,
                        calificaciontotal: total,
                        observacionesresponsable: values.observacionesresponsable,
                        observacionesinspector: values.observacionesinspector,
                        preguntas: preguntasCuestionario,
                        submit: false
                    }

                    setContextBuenasPracticas(buenaspracticasContext)
                }}

                onSubmit={async (values) => {

                    if (context.informaciongeneralContext.data.inspector != undefined) {

                        await dispatch(actualizarLoadingApp_true())
                        Promise.all(
                            guardarInformacionEnBd(values).then((response) => {
                                previsualizarDocumento(true).then((r) => {
                                    dispatch(actualizarLoadingApp_false())
                                })                               
                            })
                        )
                        const buenaspracticasContext = {
                            idcuestionario: 1,
                            califiaciones: calificaciones,
                            calificaciontotal: total,
                            observacionesresponsable: values.observacionesresponsable,
                            observacionesinspector: values.observacionesinspector,
                            preguntas: preguntasCuestionario,
                            submit: true
                        }

                        setContextBuenasPracticas(buenaspracticasContext)

                        Store.addNotification({
                            title: "Informacion guardada correctamente!",
                            message: "Guardado Correctamente",
                            type: "success",
                            insert: "top",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 10000,
                                onScreen: true
                            }
                        });

                    } else {
                        alert("Debe seleccionar un inspector")
                    }

                }}
            >
                {(props) => (
                    <Form>
                        <div id="caratula FI-25" className={`row mb-6 ${estilos.seccion}`}>
                            <div className="row mb-6">
                                {secciones &&
                                    secciones.map((s, indexSeccion) => {
                                        if (s.idseccioncuestionario === 14 || s.idseccioncuestionario === 15 || s.idseccioncuestionario === 16) {
                                            return (
                                                <Fragment key={indexSeccion}></Fragment>
                                            )
                                        } else {
                                            return (
                                                <Fragment key={indexSeccion}>
                                                    <br />
                                                    <div className='col-11' id={'seccion' + indexSeccion}>
                                                        <Collapsible trigger={s.nombre_seccion} open={false} class={`row text-center`}>
                                                            <div className='table-responsive mt-3'>
                                                                <table className='table table-striped table-hover'>
                                                                    <tbody>
                                                                        {preguntas &&
                                                                            preguntas.map((p, index) => {
                                                                                return (
                                                                                    p.pregunta.idseccioncuestionario == s.idseccioncuestionario ?
                                                                                        <tr key={index} id={'calificacioninstalaciones' + indexSeccion + index}>
                                                                                            <td className='col-8'>{p.pregunta.pregunta}</td>
                                                                                            <td className='col-4'>
                                                                                                <Field
                                                                                                    component="select"
                                                                                                    id={'calificacioninstalaciones1'}
                                                                                                    name="califiacioninstalaciones1"
                                                                                                    className={`form-select`}
                                                                                                    multiple={false}
                                                                                                    onChange={(event) => handleCalificaciones(p.idpregunta, event, indexSeccion, index)}
                                                                                                >
                                                                                                    {/* const tiposCalificacion=['Calificacion','CUMPLE PREFERENTEMENTE','CUMPLE','NO CUMPLE / NO APLICA' ]  */}
                                                                                                    {
                                                                                                        calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion === 0 ?
                                                                                                            (
                                                                                                                <Fragment>
                                                                                                                    <option value={NaN}>- - - -</option>
                                                                                                                    <option value={3}>CUMPLE PREFERENTEMENTE</option>
                                                                                                                    <option value={1}>CUMPLE</option>
                                                                                                                    <option selected value={calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion}>
                                                                                                                        {tiposCalificacion[0]}</option>
                                                                                                                </Fragment>


                                                                                                            ) :
                                                                                                            calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion === 1 ?
                                                                                                                (
                                                                                                                    <Fragment>
                                                                                                                        <option value={NaN}>- - - -</option>
                                                                                                                        <option value={3}>CUMPLE PREFERENTEMENTE</option>
                                                                                                                        <option selected value={calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion}>
                                                                                                                            {tiposCalificacion[1]}</option>
                                                                                                                        <option value={0}>NO CUMPLE / NO APLICA</option>
                                                                                                                    </Fragment>

                                                                                                                ) :
                                                                                                                calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion === 3 ?
                                                                                                                    (
                                                                                                                        <Fragment>
                                                                                                                            <option value={NaN}>- - - -</option>
                                                                                                                            <option selected value={calificaciones.find(calificacion => calificacion.idpregunta === p.idpregunta)?.calificacion}>
                                                                                                                                {tiposCalificacion[3]}</option>
                                                                                                                            <option value={1}>CUMPLE</option>
                                                                                                                            <option value={0}>NO CUMPLE / NO APLICA</option>

                                                                                                                        </Fragment>
                                                                                                                    ) :
                                                                                                                    (
                                                                                                                        <Fragment>
                                                                                                                            <option value={NaN}>- - - -</option>
                                                                                                                            <option value={3}>CUMPLE PREFERENTEMENTE</option>
                                                                                                                            <option value={1}>CUMPLE</option>
                                                                                                                            <option value={0}>NO CUMPLE / NO APLICA</option>
                                                                                                                        </Fragment>
                                                                                                                    )
                                                                                                    }
                                                                                                </Field>
                                                                                            </td>
                                                                                        </tr>
                                                                                        : <tr key={index}></tr>
                                                                                )
                                                                            })}
                                                                    </tbody>
                                                                </table>
                                                                <hr></hr><br /><br />
                                                            </div>
                                                        </Collapsible>
                                                    </div>
                                                    <div className='col-1' id={'check' + indexSeccion}>
                                                        <DoneAllIcon color='success' fontSize='medium' /><br />
                                                        <input className='control' type='checkbox' onChange={(event) => checkSeccion(event, indexSeccion)}></input>
                                                    </div>
                                                    <br />
                                                </Fragment>
                                            )
                                        }
                                    })}
                                <hr />
                                <div>
                                    <h4 ><strong>PUNTAJE TOTAL: {total}</strong></h4>
                                </div>
                                <hr />
                            </div>
                            <p><strong>*LOS APARTADOS ESTAN BASADOS EN LA NORMA OFICIAL MEXICANA NOM-251-SSA1-2009, PRACTICAS DE HIGIENE PARA EL PROCESO DE ALIMENTOS, BEBIDAS O SUPLEMENTOS ALIMENTICIOS.</strong></p>
                            <div className="row mb-6">
                                <div className='row'>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="observacionesinspector">Observaciones del inspector</label>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <Field type="text" as="textarea" className="form-control form-control-sm" id="observacionesinspector" name="observacionesinspector" placeholder="Comentarios" />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="observacionesresponsable">Observaciones del Responsable de las Instalaciones</label>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <Field type="text" as="textarea" className="form-control form-control-sm" id="observacionesresponsable" name="observacionesresponsable" placeholder="Comentarios" />
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            {
                                idtipoinstalacion === 1 ?
                                    (
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>UNIDAD</th>
                                                        <th>CUMPLIMIENTO (REQUISITOS MINIMOS)</th>
                                                        <th>ATRIBUTO BPM (PREFERENTE)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>PRODUCCIÓN</td>
                                                        <td>41</td>
                                                        <td>85</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    ) :
                                    idtipoinstalacion === 2 ?
                                        (
                                            <div className='table-responsive'>
                                                <table className='table table-striped table-hover'>
                                                    <thead>
                                                        <tr>
                                                            <th>UNIDAD</th>
                                                            <th>CUMPLIMIENTO (REQUISITOS MINIMOS)</th>
                                                            <th>ATRIBUTO BPM (PREFERENTE)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>ENVASADO</td>
                                                            <td>61</td>
                                                            <td>103</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) :
                                        idtipoinstalacion === 3 ?
                                            (
                                                <div className='table-responsive'>
                                                    <table className='table table-striped table-hover'>
                                                        <thead>
                                                            <tr>
                                                                <th>UNIDAD</th>
                                                                <th>CUMPLIMIENTO (REQUISITOS MINIMOS)</th>
                                                                <th>ATRIBUTO BPM (PREFERENTE)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>ALMACEN</td>
                                                                <td>22</td>
                                                                <td>NO APLICA</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) :
                                            <div />
                            }
                            {
                                informacionGuardada === false ?
                                    <div className="row mb-5">
                                        <div className="col ">
                                            <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR INFORMACION</button>
                                        </div>
                                    </div>
                                    :
                                    <div>

                                    </div>
                            }
                            <hr />


                            <div className="row mb-5">
                                {informacionGuardada === false ?
                                    <div className='col'>
                                        <button className='btn btn-warning' type='button' onClick={() => previsualizarDocumento(false)} ><VisibilityIcon /> PREVISUALIZAR INFORME</button>
                                    </div>
                                    :
                                    <div>
                                    </div>
                                }
                                {/* {
                                    informacionGuardada === true ?
                                        <div className='col'>
                                            <button className='btn btn-primary' type='button' onClick={() => previsualizarDocumento(true)}><DocumentScannerIcon></DocumentScannerIcon>GENERAR INFORME</button>

                                        </div>
                                        :
                                        <div></div>
                                } */}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <div>
                {modalPrevisualizarPDF()}
            </div>
        </Fragment>
    )
}

export default withRouter(BuenasPracticasComponent)